import { formatMoney } from '@/utils/format-money';

export const budgets = [
  {
    label: `Até ${formatMoney(50)}`,
    value: '50.0',
  },
  {
    label: `Até ${formatMoney(100)}`,
    value: '100.0',
  },
  {
    label: `Até ${formatMoney(300)}`,
    value: '300.0',
  },
  {
    label: `Até ${formatMoney(1000)}`,
    value: '1000.0',
  },
  {
    label: 'Qualquer valor',
    value: null,
  },
];
